import { apiSlice } from "../store/app.api";
import { supabase } from "../utils/API";

export type AdminNotification = {
  id: number;
  admin_id: number;
  type: string;
  title: string;
  message: string;
  reference_id: string | null;
  is_read: boolean;
  created_at: string;
};

const notificationApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getAdminNotifications: build.query<AdminNotification[], number>({
      queryFn: async (adminId) => {
        const { data, error } = await supabase
          .from("admin_notifications")
          .select("*")
          .eq("admin_id", adminId)
          .order("created_at", { ascending: false })
          .limit(50); // Get latest 50 notifications

        if (error) return { error };
        return { data: data || [] };
      },
      providesTags: ["notifications"],
    }),
    markNotificationAsRead: build.mutation<void, number>({
      queryFn: async (notificationId) => {
        const { error } = await supabase
          .from("admin_notifications")
          .update({ is_read: true })
          .eq("id", notificationId);

        if (error) return { error };
        return { data: undefined };
      },
      invalidatesTags: ["notifications"],
    }),
    markAllNotificationsAsRead: build.mutation<void, number>({
      queryFn: async (adminId) => {
        const { error } = await supabase
          .from("admin_notifications")
          .update({ is_read: true })
          .eq("admin_id", adminId)
          .eq("is_read", false);

        if (error) return { error };
        return { data: undefined };
      },
      invalidatesTags: ["notifications"],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetAdminNotificationsQuery,
  useMarkNotificationAsReadMutation,
  useMarkAllNotificationsAsReadMutation,
} = notificationApi;
